<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="wrap">
      <div class="clear branch">
        <div class="swiper-container" id="swiper-plan">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in branch" :key="index" @click="changeTab(item)">
              <div class="item" :style="{backgroundImage:'url('+(tab.id == item.id ? item.bg2 : item.bg)+')'}" :class="[tab.id == item.id ? 'active' : '']">
                <div class="cen">
                  <div class="middle">
                    <div class="icon"><img :src="item.icon" alt=""></div>
                    <div class="icon icon-a"><img :src="item.image" alt=""></div>
                    <div class="tit">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear result">
        <div class="title-box">
          <div class="left date">08/21</div>
          <div class="left title">
            <div class="tit">进化 乘势而上</div>
            <div class="min-tit">2026戴尔科技峰会暨「进化者」论坛</div>
          </div>
        </div>
        <div class="list">
          <div class="clear item fuck-your-sister" v-for="(item,index) in topic_filter" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']"
               @click="toSession(item,index)">
            <div class=" time-box">
              <div class="line line-1"></div>
              <div class="left time">{{ tool.date.formatDate("H:i", item.live_start) }}-{{ tool.date.formatDate("H:i", item.live_end) }}</div>
              <div class="line line-2"></div>
            </div>
            <div class=" info-box">
              <div class=" info">
                <div class="title">{{ item.title }}</div>
                <div class="speaker">
                  <div class="ll" v-for="(v,i) in item.speaker" v-if="v.username"><span>{{ v.username }}</span><i v-if="v.job">|</i><span v-html="v.job"></span></div>
                </div>
                <div class="issue" v-if="item.issue">
                  <div class="ll" v-for="(v,i) in item.issue">
                    <div class="tit">{{ i }}</div>
                    <div class="all">
                      <div class="speaker-ll" v-for="(vv,ii) in v" v-if="vv.username"><span>{{ vv.username }}</span><i v-if="vv.job">丨</i><span v-html="vv.job"></span></div>
                    </div>
                  </div>
                </div>
                <div class="status-box">
                  <div class="status" :class="[tool.array.inArray(live_active,sessionStatus(item,index)) ? 'active' : '']">
                    <p>{{ statusText(sessionStatus(item, index)) }}</p>
                  </div>
                  <div class="star" :class="[inStar(item) ? 'active' : '']" @click.stop="star(item)">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tips" v-if="topic_filter.length > 0"><i>* </i>实际日程以直播当天为准</div>
        <div class="data-loading" v-if="data_loading">
          <loading></loading>
        </div>
      </div>
      <sponsor/>
    </div>
    <div class="all-mark" v-if="all_mark"></div>
  </main>
</template>

<script>
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
import Sponsor from "@/components/pc/Sponsor";

export default {
  name: "plan",
  data() {
    return {
      query: "",
      key: "",
      room_list: [],
      room: {},
      session: [],
      topic: [],
      all_mark: true,
      data_loading: true,
      time_list: [],
      now_time: 0,
      live_active: [2, 3, 5],
      star_list: [],
      branch: [
        {
          id: 1,
          title: "主会场",
          icon: require("@/assets/image/2022/17.png"),
          image: require("@/assets/image/2022/18.png"),
          bg: require("@/assets/image/2022/16.png"),
          bg2: require("@/assets/image/2022/15.png")
        },
        {
          id: 2,
          title: "第二现场",
          icon: require("@/assets/image/2022/19.png"),
          image: require("@/assets/image/2022/21.png"),
          bg: require("@/assets/image/2022/20.png"),
          bg2: require("@/assets/image/2022/22.png")
        }
      ],
      tab: {id: 1}
    };
  },
  components: {
    Loading, Sponsor, Crumbs
  },
  computed: {
    week_array() {
      return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    },
    crumbs() {
      return {title: "主会场", min_title: "KEYNOTE"};
    },
    is_login() {
      return this.util.getAccessToken();
    },
    topic_filter() {
      return this.topic.filter((item, index) => {
        return Number(item.type) === Number(this.tab.id);
      });
    }
  },
  watch: {
    now_time(newVal, oldVal) {
      if (newVal > oldVal && this.util.inArray(newVal, this.time_list)) {
        this.getTopic();
      }
    }
  },
  methods: {
    changeTab(item) {
      // if(item.id === 2){
      // 	this.util.showWait(true);
      // 	return false;
      // }
      if (item.link) {
        window.location.href = item.link;
      } else {
        this.tab.id = item.id;
      }
    },
    swiperInit() {
      this.swiper = new Swiper("#swiper-plan", {
        slidesPerView: 4,
        spaceBetween: 40,
        watchOverflow: true,
        slideToClickedSlide: true,
        observer: true,
        observeSlideChildren: true
      });
    },
    statusText(status) {
      var text = ["敬请期待", "即将开始", "正在直播", "已结束", "直播回放"];
      return text[status - 1];
    },
    setForm(item) {
      this.room = item;
      this.getSession();
    },
    toSession(item, index) {
      var status = this.sessionStatus(item, index);
      if (!this.tool.array.inArray(this.live_active, status)) {
        return false;
      } else {
        if (item.live_url) {
          window.open(item.live_url, "_blank");
        } else {
          //var url = this.global.MUDU_HOST +item.live_code;
          if (this.$store.state.user_info.id) {
            var router = this.$router.resolve({
              path: "/auth",
              query: {
                live_event: item.live_event,
                live_code: item.live_code,
                live_type: item.live_type,
                title: item.title
                //redirect:url
              }
            });
            window.open(router.href, "_blank");
          } else {
            var from = `/auth?live_code=${item.live_code}&live_type=${item.live_type}&live_event=${item.live_event}&title=${item.title}`;
            this.util.showAuth({
              show: true,
              from: from
            });
          }
        }
      }
    },
    inStar(row) {
      return this.star_list.find((item, index) => {
        return Number(item.topic_id) === Number(row.id);
      });
    },
    star(item) {
      if (!this.is_login) {
        this.util.showAuth({
          show: true,
          from: "/plan"
        });
      } else {
        this.http.request({
          api: "user/star",
          data: {
            type: 1,
            topic_id: item.id
          },
          success: (res) => {
            this.getStarList();
          }
        });
      }
    },
    getStarList() {
      if (!this.is_login) {
        return false;
      }
      this.http.request({
        api: "user/starList",
        data: {
          type: 1
        },
        success: (res) => {
          this.star_list = res.list;
        }
      });
    },
    sessionStatus(item, index) {
      if (item.live_status > 0) {
        return item.live_status;
      }
      var now_time = this.now_time;
      if (now_time < parseInt(item.live_start)) {
        if (index == 0) {
          if (now_time < parseInt(item.live_start) - 30 * 60) {
            return 1;
          } else {
            return 2;
          }
        } else {
          return 1;
        }
      } else if (now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)) {
        return 3;
      } else {
        return 4;
      }
    },
    removeKey() {
      this.key = "";
      this.getSession();
    },
    getTopic() {
      this.http.request({
        api: "main/getTopic",
        success: (res) => {
          var list = res.list;
          list.map((item, index) => {
            var issue = {};
            var speaker = [];
            if (item.issue && item.issue.length > 0) {
              item.issue.map((v, i) => {
                if (v.title) {
                  if (!issue[v.title]) {
                    issue[v.title] = [];
                  }
                  issue[v.title].push(v);
                } else {
                  speaker.push(v);
                }
              });
            }
            item.issue = Object.getOwnPropertyNames(issue).length > 0 ? issue : false;
            item.speaker = speaker;
          });

          this.topic = list;
          if (this.tool.other.getUrlParams("timer") == "local") {
            this.now_time = Math.floor(new Date().getTime() / 1000);
          } else {
            this.now_time = res.service_time;
          }
          this.refresh();

          var time_list = [];
          for (var i = 0; i < this.topic.length; i++) {
            time_list.push(this.topic[i].live_start);
            time_list.push(this.topic[i].live_end);
          }
          this.time_list = time_list;

          this.$nextTick(() => {
            this.data_loading = false;
            this.util.showBottom(true);
            this.fuckSister()
          });
        }
      });
    },
    fuckSister() {
      const dom = document.querySelectorAll(".fuck-your-sister.active")[0];
      if (dom) {
        const t = dom.getBoundingClientRect().top - 90;
        document.body.scrollTop = document.documentElement.scrollTop = t;
      }
    },
    refresh() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.now_time = this.now_time + 1;
      }, 1000);
    }
  },
  mounted() {
    this.query = this.$route.query;
    this.getTopic();
    this.getStarList();
    this.swiperInit();
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" type="text/scss" scoped>
.wrap {
  background: #f6f6f6;
  padding-top: 20px;
  background-size: 100% auto;

  .category {
    width: 1200px;
    margin: 0 auto;
    display: none;

    .list {
      overflow: hidden;

      .item {
        float: left;
        padding: 0 15px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border: 1px solid #63b4e1;
        color: #565656;
        transition: all .3s ease;
        cursor: pointer;
        margin-right: 8px;
        margin-bottom: 20px;
        display: none;
      }

      .item.item-l {
        border-color: #0170c3;
        display: block;
      }

      .item:hover {
        background: #00447c;
        transition: all .3s ease;
        color: #fff;
      }

      .item.active {
        background: #0176ce;
        transition: all .3s ease;
        color: #fff;
      }
    }
  }

  .search-box {
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;
    display: none;

    .in {
      display: block;
      float: left;
      width: 840px;
      height: 50px;
      padding: 0 20px;
      line-height: 50px;
      font-size: 16px;
      background: #fff;
      border: none;
    }

    .clear {
      display: block;
      float: left;
      width: 170px;
      height: 50px;
      line-height: 50px;
      color: #929292;
      font-size: 16px;
      background: #f9f9f9;
      border: none;
      text-align: center;
      cursor: pointer;
    }

    .btn {
      display: block;
      float: left;
      width: 150px;
      height: 50px;
      line-height: 50px;
      color: #fff;
      font-size: 16px;
      background: #0176ce;
      border: none;
      text-align: center;
      cursor: pointer;

      i {
        padding-left: 30px;
        background: url("~@/assets/image/34.png") no-repeat left center;
        background-size: 20px;
      }
    }

    .btn.hidden {
      background: #b8b8b8;
    }
  }

  .branch {
    width: 1220px;
    margin: 0 auto 0;
    display: none;

    .swiper-container {
      padding: 10px;

      .item {
        height: 140px;
        margin-right: 30px;
        border-radius: 5px;
        box-shadow: 0 0 .1rem .02rem rgba(0, 0, 0, .1);
        position: relative;
        cursor: pointer;
        text-align: center;
        transition: all .3s ease;

        .cen {
          display: inline-block;

          .middle {
            text-align: center;
            transition: all .3s ease;
            height: 140px;

            .icon {
              width: 50px;
              height: 70px;
              display: block;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .icon-a {
              display: none;
            }

            .tit {
              color: #2d576f;
              font-size: 16px;
              line-height: 36px;
            }
          }
        }
      }

      .item.active {
        transition: all .3s ease;
        background: url("~@/assets/image/b44.jpg") no-repeat center center;
        background-size: cover;

        .cen {
          .middle {
            .icon {
              display: none;
            }

            .icon-a {
              display: block;
            }

            .tit {
              color: #232846;
            }
          }
        }
      }

      .item:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }

  .result {
    width: 1200px;
    margin: 20px auto 0;
    padding-bottom: 50px;

    .title-box {
      overflow: hidden;

      .date {
        height: 100px;
        line-height: 100px;
        font-size: 66px;
        color: #0672cb;
        font-weight: 100;
        background: url("~@/assets/image/2021/10.png") no-repeat center center;
        background-size: contain;
      }

      .title {
        margin-left: 70px;

        .tit {
          font-size: 54px;
          color: #0672cb;
        }

        .min-tit {
          font-size: 18px;
          line-height: 24px;
          margin-top: 9px;
          color: #808080;
        }
      }
    }

    .list {
      overflow: hidden;
      margin-top: 20px;
      padding-bottom: 30px;
      padding-top: 30px;

      .item {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;

        .time-box {
          display: flex;
          flex-direction: column;
          width: 160px;

          .line {
            position: relative;
          }

          .line::after {
            content: "";
            display: block;
            position: absolute;
            left: 10px;
            top: 0;
            width: 1px;
            height: 100%;
            background: #979797;
          }

          .line-1 {
            height: 16px;
          }

          .time {
            font-size: 18px;
            height: 40px;
            line-height: 40px;
            font-weight: bold;
            background: url("~@/assets/image/2021/14.png") no-repeat left center;
            background-size: 24px;
            padding-left: 40px;
          }

          .line-2 {
            flex: 1;
          }
        ;
        }

        .info-box {
          padding-bottom: 18px;
          flex: 1;

          .info {
            padding: 25px;
            background: #fff;
            box-shadow: 0 0 10px 2px rgba(0, 0, 0, .1);
            position: relative;

            .title {
              font-size: 16px;
              font-weight: bold;
              color: #1A1A1A;
            }

            .speaker {
              font-size: 14px;
              color: #808080;
              margin-top: 10px;
              display: flex;

              span, i {
                display: block;
                float: left;
              }

              span:nth-child(1) {
                min-width: 45px;
                display: inline-block;
                text-align: justify;
                text-align-last: justify;
              }

              i {
                padding: 0 10px;
              }

              span:nth-last-child(1) {
                flex: 1;
              }
            }

            .issue {
              padding-top: 30px;
              background: url("~@/assets/image/2021/18.png") no-repeat top center;
              background-size: 100% 15px;
              overflow: hidden;
              display: flex;
              flex-wrap: wrap;

              .ll {
                width: 455px;
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 40px;
                margin-right: 30px;

                .tit {
                  font-size: 14px;
                  color: #0672cb;
                  font-weight: bold;
                }

                .all {
                  width: 100%;

                  .speaker-ll {
                    font-size: 14px;
                    color: #808080;
                    margin-top: 10px;
                    display: flex;

                    span, i {
                      display: block;
                      float: left;
                    }

                    span:nth-child(1) {
                      min-width: 45px;
                      display: inline-block;
                      text-align: justify;
                      text-align-last: justify;
                    }

                    i {
                      padding: 0 10px;
                    }

                    span:nth-last-child(1) {
                      flex: 1;
                    }
                  }
                }
              }

              .ll:nth-child(2n) {
                margin-right: 0;
              }
            }

            .status-box {
              position: absolute;
              bottom: 0;
              right: 0;
              display: flex;

              .status {
                width: 110px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: #9F9F9F;
                color: #fff;
                border-right: 1px solid #fff;

                p {
                  padding-left: 20px;
                  background: url("~@/assets/image/2021/16.png") no-repeat left center;
                  background-size: 12px;
                  display: inline-block;
                }
              }

              .status.active {
                background: #0672cb;
                cursor: pointer;
              }

              .star {
                width: 110px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: #0672cb;
                color: #fff;
                transition: all .3s ease;

                p {
                  padding-left: 22px;
                  background: url("~@/assets/image/2022/10.png") no-repeat left center;
                  background-size: 17px;
                  display: inline-block;
                  transition: all .3s ease;
                }

                p::after {
                  content: "收藏"
                }
              }

              .star.active {
                background: #9F9F9F;
                cursor: pointer;
                transition: all .3s ease;

                p {
                  background-image: url("~@/assets/image/2022/11.png");
                  background-size: 17px;
                  transition: all .3s ease;
                }

                p::after {
                  content: "已收藏"
                }
              }

              .star.active:hover {
                background: rgba(0, 118, 206, .7);
                transition: all .3s ease;

                p::after {
                  content: "取消收藏"
                }
              }
            }
          }
        }
      }

      .item.active {
        cursor: pointer;

        .time {
          background: url("~@/assets/image/2024/icon06.png") no-repeat left center;
          background-size: 24px;
        }
      }

      .item:nth-last-child(1) {
        .info-box {
          padding-bottom: 0;
        }
      }
    }

    .tips {
      text-align: left;
      color: #999;
      height: 60px;
      line-height: 60px;
      font-size: 14px;

      i {
        color: red;
      }
    }
  }
}

.all_mark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: #fff;
  display: none;
}
</style>

